import React, { Component } from 'react';
import Modal from 'react-modal';

import { StyleSheet, css } from 'aphrodite';
import { Flexbox, ColorEnvironment, Layout, Responsive, Font, Text, Dialog } from './Styles';
import Exit from './images/exit.png';
import Toolbox from './images/toolbox.png';
import Menu from './images/menu.png';
import Cancel from './images/cancel.png';

import Configuration from './models/Configuration';

import ScoreComponent from './ScoreComponent';
import HazardComponent from './HazardComponent';
import ButtonSet from './ButtonSet';
import ActionToolbox from './ActionToolbox';
import ActionCard from './ActionCard';
import HazardInfo from './HazardInfo';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  exitButton: {
    height: 65,
    width: 65,
    marginTop: 40,
    marginLeft: 10,
    backgroundSize: '100% 100%',
    backgroundImage: `url(${Exit})`,
    '@media (max-width: 420px)': {
      marginTop: 30,
      height: 30,
      width: 30,
      alignSelf: 'flex-start'
    }
  },
  actionButtonContainer: {
    height: 65,
    width: 65,
    marginTop: 25,
    marginRight: 10,
  },
  actionButton: {
    backgroundImage: `url(${Toolbox})`
  },
  menuButton: {
    height: 65,
    width: 65,
    marginTop: 40,
    marginRight: 10,
    backgroundSize: '100% 100%',
    backgroundImage: `url(${Menu})`,
    '@media (max-width: 420px)': {
      marginTop: 30,
      height: 30,
      width: 30,
      alignSelf: 'flex-start'
    }
  },
  heading: {
    marginTop: 20,
    marginBottom: 10
  },
  cityName: {
    minWidth: 50,
    marginLeft: 20,
    marginRight: 20
  },
  menu: {
    position: 'relative',
    height: 'calc(100% - 120px)',
    marginTop: 120
  },
  menuCancel: {
    position: 'absolute',
    top: 10,
    right: 10,
    height: 50,
    width: 50,
    backgroundImage: `url(${Cancel})`
  },
  menuContent: {
    position: 'absolute',
    top: 60,
    left: 0,
    right: 0,
    bottom: 0,
    overflowX: 'auto'
  }
});

class Scoreboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExitConfirm: false,
      showHazard: null,
      showActionToolbox: false,
      showMenu: false
    };
  }

  renderModals() {
    return(
      <div>
        <Modal isOpen={this.state.showActionToolbox} contentLabel="Toolbox" className={css(Layout.modal)} onRequestClose={ () => { this.setState({showActionToolbox: false}) } }>
          <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)}>
            <ActionToolbox actions={this.props.actions} onClose={ () => { this.setState({showActionToolbox: false}) } }/>
          </div>
        </Modal>
        <Modal isOpen={this.state.showMenu} contentLabel="Menu" className={css(Layout.modal)} onRequestClose={ () => { this.setState({showMenu: false}) } }>
          <div className={css(ColorEnvironment.secondaryInverse, styles.menu)}>
            <div className={css(styles.menuCancel)} onClick={ () => { this.setState({showMenu: false}) } } />
            <div className={css(styles.menuContent)}>
              <div className={css(Flexbox.column, Flexbox.crossCenter)}>
                {this.renderProfile()}
                <div className={css(Font.heading, Text.heading, styles.heading)}>{Locale.localized("Action Toolbox")}</div>
                {this.props.actions.map(action => {
                  return <ActionCard key={action.description} action={action}/>
                })}
                {this.props.actions.length === 0 &&
                  <div className={css(Font.body, Text.textBlock)}>{Locale.localized("You don't have any actions in your toolbox yet")}</div>
                }
              </div>
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.showExitConfirm} contentLabel="Exit" className={css(Layout.modal)} onRequestClose={ () => { this.setState({showExitConfirm: false}) } }>
          <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)}>
            <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
              <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, Dialog.container, ColorEnvironment.normal)}>
                <div className={css(Flexbox.grow, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)}>
                  <div className={css(Font.heading, Text.heading)}>{Locale.localized("Are you sure you want to exit the game?")}</div>
                </div>
                <ButtonSet buttons={[[Locale.localized("Yes, exit"), "/"], [Locale.localized("No, keep playing"), () => { this.setState({showExitConfirm: false}) }]]} />
              </div>
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.showHazard != null} contentLabel="Hazard" className={css(Layout.modal)} onRequestClose={ () => { this.setState({showHazard: null}) } }>
          <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)}>
            <HazardInfo hazard={this.state.showHazard} onClose={ () => { this.setState({showHazard: null}) } }/>
          </div>
        </Modal>
      </div>
    );
  }

  renderExitButton() {
    return(
      <div className={css(styles.exitButton)} onClick={ () => { this.setState({showExitConfirm: true}) } }/>
    );
  }

  renderScore(mobile) {
    let title = mobile? this.props.scenario.name : Locale.localized("Status");
    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(styles.heading, Font.heading)}>{title}</div>
        <div className={css(Flexbox.row, Flexbox.axisStart, Flexbox.crossFill)}>
          <ScoreComponent compact={mobile} value={this.props.score.c} max={Configuration.maxScore.c} prefix='$' label={Locale.localized("Money")}/>
          <ScoreComponent compact={mobile} value={this.props.score.p} max={Configuration.maxScore.p} label={Locale.localized("Preparedness")}/>
          <ScoreComponent compact={mobile} value={this.props.score.q} max={Configuration.maxScore.q} label={Locale.localized("Quality of Life")}/>
        </div>
      </div>
    );
  }

  renderTitle() {
    let cityNameComponents = this.props.scenario.name.split(' ');
    return(
      <div className={css(Responsive.onlyFullWidth, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, styles.cityName)}>
        {this.props.showTitle && 
          <div className={css(Font.tight)}>
            <div className={css(Font.scoreboardHero, Font.heroInset)}>{cityNameComponents[0]}</div>
            {cityNameComponents.slice(1).map(name => {
              return <div className={css(Font.scoreboardHero)} key={name}>{name}</div>
            })}
          </div>
        }
      </div>
    );
  }

  renderProfile() {
   let hazards = this.props.scenario.eventsByHazard()
    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(styles.heading, Font.heading)}>{Locale.localized("Risk Profile")}</div>
        <div className={css(Flexbox.row, Flexbox.axisStart, Flexbox.crossStart)}>
          {hazards.map(hazard => {
            return <HazardComponent key={hazard.hazard} hazard={hazard} onClick={ () => { this.setState({showHazard: hazard}) } }/>
          })}
        </div>
      </div>
    );
  }

  renderActionButton() {
    if (this.props.hideActionButton) {
      return(
        <div className={css(styles.actionButtonContainer)} />
      );
    } else {
      return(
        <div className={css(styles.actionButtonContainer, styles.actionButton)} onClick={ () => { this.setState({showActionToolbox: true}) } }/>
      );
    }
  }

  renderMenuButton() {
    return(
      <div className={css(styles.menuButton)} onClick={ () => { this.setState({showMenu: true}) } }/>
    );
  }

  render() {
    return(
      <div>
        {this.renderModals()}
        <div className={css(Responsive.notOnMobile, Layout.scoreboardContainer, Flexbox.row, Flexbox.axisCenter)}>
          <div className={css(Layout.scoreboard, Flexbox.row, Flexbox.axisFill, Flexbox.crossCenter)}>
            {this.renderExitButton()}
            <div className={css(Flexbox.grow, Flexbox.row, Flexbox.axisCenter, Flexbox.crossFill)}>
              {this.renderScore()}
              {this.renderTitle()}
              {this.renderProfile()}
            </div>
            {this.renderActionButton()}
          </div>
        </div>

        <div className={css(Responsive.onlyOnMobile, Layout.scoreboardContainer, Flexbox.row, Flexbox.axisCenter)}>
          <div className={css(Layout.scoreboard, Flexbox.row, Flexbox.axisBetween, Flexbox.crossCenter)}>
            {this.renderExitButton()}
            {this.renderScore(true)}
            {this.renderMenuButton()}
          </div>
        </div>
      </div>
    );
  }
}

export default Scoreboard;



// WEBPACK FOOTER //
// ./src/Scoreboard.js